import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';
import { colours } from '@shared/theme/colours';

import { styles } from './CurrencyPound.styles';

export interface CurrencyPoundIconProps extends WithStyles<typeof styles> {
  color?: string;
}

const CurrencyPoundIconComponent: FC<CurrencyPoundIconProps> = ({ classes, color = colours.neutral[400] }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      classes={{ root: classes.root }}
    >
      <g clipPath="url(#clip0_889_17952)">
        <path
          d="M10.0002 11.6663H6.00016C6.00016 11.6663 7.3335 10.1626 7.3335 8.33301C7.3335 7.33301 6.61002 6.9908 6.59705 5.97437C6.5979 3.96236 9.01998 4.06934 9.86186 4.86902M6.00016 8.33301H9.3335M14.6668 7.99967C14.6668 11.6816 11.6821 14.6663 8.00016 14.6663C4.31826 14.6663 1.3335 11.6816 1.3335 7.99967C1.3335 4.31778 4.31826 1.33301 8.00016 1.33301C11.6821 1.33301 14.6668 4.31778 14.6668 7.99967Z"
          stroke={color}
          strokeWidth="1.67"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_889_17952">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export const CurrencyPoundIcon = withStyles(styles)(CurrencyPoundIconComponent);
